import React, { useEffect, useState } from "react";
import { URInput } from "../input";
import styles from "./chatGif.module.scss";
//*import mail2 from "../../../styles/images/1b.png";
import axios from "axios";
import { GetGif } from "../../../base/constant";
//*import { ChatService } from "../../../base/chatService";
import { fileUploadSocket } from "../../../base/socketChatService/utils";
import { Tooltip } from "antd";
function URChatGIF() {

  const [showGif , setGif] = useState([]);

  useEffect(() => {
    let str: string = "alphabet";
    loadgif(str);
  }, []);

/**
 * @description Search gif 
 * @param e 
 */
  const gifsearch = (e:any) =>
  {
    let str:any = e.target.value;
    if(str === "" || str === undefined)
    {
      str = "happy";
    }
    loadgif(str);
  };

/**
 * @description Get Stickers from API
 * @param str 
 * @returns 
 */
  const loadgif = (str:string) =>
  {
    const url:string = GetGif(str);
    return axios
      .get(url)
      .then((res:any) => {
        setGif(res.data.data);
      })
      .catch((err:any) => {});
  };

  /**
   * @description Send Selected Gif
   * @param url 
   * @param fileName 
   */
  const bindgif = (url:string,fileName:string)=>{
    let filesinfo:any = {};
    let fileType:any = "image/gif";
    fileName = fileName.replace(/"/g, "");
    fileName = fileName.trim();
    var blob;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = async function()
    {
      blob = xhr.response;
      let file:any = await  new File([blob], fileName, { type: fileType });
      filesinfo.fileName = file.name;
      filesinfo.fileType = file.type;
      filesinfo.filePath =  window.URL.createObjectURL(file);
      filesinfo.filesize =file.size;
      filesinfo.targetFile = file;
      filesinfo.messageType = "IMAGE";
      filesinfo.isCloudfiles = false
      fileUploadSocket(filesinfo);
    };
    xhr.send();
  };

  return (
    <>
      <div className={styles.popOverContainer}>
        <div className={styles.topHeadersec}>
          <div className={styles.listdrapdrop}>
            <ul className={styles.toplistIcon}>             
                <Tooltip mouseEnterDelay={0.5}  placement="top" title="Frequently Used"><li className={styles.active}>
                    <span className="icon_clock"></span> 
                </li></Tooltip>
                <Tooltip  mouseEnterDelay={0.5} placement="top" title="Angry"><li onClick={()=>loadgif("angry")}>
                    <span className="icon_anger"></span> 
                </li></Tooltip>
                <Tooltip  mouseEnterDelay={0.5} placement="top" title="Sad"><li onClick={()=>loadgif("sad")}>
                    <span className="icon_sad"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Confused"><li onClick={()=>loadgif("confused")}>
                    <span className="icon_confussion"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Happy"><li onClick={()=>loadgif("Happy")}>
                    <span className="icon_happy"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Strong"><li onClick={()=>loadgif("Strong")}>
                    <span className="icon_strong"></span> 
                </li></Tooltip>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Energised"><li onClick={()=>loadgif("Energised")}>
                    <span className="icon_smile"></span> 
                </li></Tooltip>
              </ul>     
            </div>
          </div>
        <div className={styles.middleHeadersec}>
          <URInput placeHolder='Search' className='searchBox gifSearch' onChange={(e:any)=>gifsearch(e)}/>
          {/* <span className="icon_close"></span> */}
        </div>
        <div className={styles.topInnerBodySec}>
        <h3>Frequently Used</h3>
          <div className={`${styles.listdrapdrop} scroller`}>
            <ul className={styles.orderItem}>
              {showGif && showGif.map((data:any, i:any) => {
                let preview:any = data.images;
                let downloadLink:any = preview.downsized.url;
                return(
                  <li key={i}>
                    <img src={downloadLink} alt=""
                      onClick={() => bindgif(downloadLink, JSON.stringify(data.title+'.gif'))} />
                  </li>
                );
              })
              }
            </ul>
          </div>
        </div>
      
      </div>
    </>
  );
}

export {
  URChatGIF
};